import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiUpload, FiTarget, FiZap } = FiIcons;

const SolutionSection = () => {
  const steps = [
    {
      icon: FiUpload,
      title: "Brain Dump",
      description: "Get everything out of your head. All the chaos, all the brilliance, all the half-formed thoughts.",
      color: "text-purple"
    },
    {
      icon: FiTarget,
      title: "We Organize",
      description: "Our system sorts your chaos into clear, actionable steps. No overwhelm, no judgment.",
      color: "text-teal"
    },
    {
      icon: FiZap,
      title: "You Focus",
      description: "See exactly what to work on next. Your energy, your rhythm, your brilliant brain—just clearer.",
      color: "text-gold"
    }
  ];

  return (
    <section id="solution" className="solution-section">
      <div className="container mx-auto px-6 py-20">
        <motion.div 
          className="section-header text-center"
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">
            From chaos to clarity in minutes
          </h2>
          <p className="section-description">
            Structure that flows, not constricts. Clarity without compromise.
          </p>
        </motion.div>
        
        <div className="steps-container">
          {steps.map((step, index) => (
            <motion.div 
              key={index}
              className="step-card"
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <div className={`step-icon ${step.color}`}>
                <SafeIcon icon={step.icon} />
              </div>
              <div className="step-content">
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="step-arrow">→</div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;